import { render } from "./RSelect.vue?vue&type=template&id=198a6c32"
import script from "./RSelect.vue?vue&type=script&lang=js"
export * from "./RSelect.vue?vue&type=script&lang=js"

import "./RSelect.vue?vue&type=style&index=0&id=198a6c32&lang=css"
script.render = render

export default script